'use client';

import React from 'react';
import {
  allCssVariablesAtom,
  enableKatexAtom,
  extractCoverImageAtom,
  homeCssAtom,
  homeCssVariablesAtom,
  postCssAtom,
  showCodeLineNumberAtom,
} from 'app/blog/[domain]/_components/design-state';
import {
  CODE_LINE_NUMBER_STYLE,
  HIDE_COVER_STYLE,
} from 'app/blog/[domain]/(standalone)/post/[slug]/_components/article/dynamic-styles';
import { useAtomValue } from 'jotai';
import type { DesignTab } from '../design-tabs';

export function IframeStyle({ tab }: { tab: DesignTab }) {
  const showCodeLineNumber = useAtomValue(showCodeLineNumberAtom);
  const extractCoverImage = useAtomValue(extractCoverImageAtom);
  const enableKatex = useAtomValue(enableKatexAtom);
  const homeCss = useAtomValue(homeCssAtom);
  const postCss = useAtomValue(postCssAtom);
  return (
    <>
      {/* Fix toast show up in blog design mode */}
      <style id="toast">{`
        [data-sonner-toaster='true'] {
          display: none !important;
        }
        `}</style>
      {['all', 'home'].includes(tab) && (
        <>
          <style id="home-css">{homeCss}</style>
          <HomeCSSVariables />
        </>
      )}
      {tab === 'post' && (
        <>
          <style id="post-body">{`
            ${showCodeLineNumber ? CODE_LINE_NUMBER_STYLE : ''}

            ${extractCoverImage ? HIDE_COVER_STYLE : ''}
          `}</style>
          {enableKatex && (
            <link
              href="https://esm.sh/katex@0.16.11/dist/katex.min.css"
              rel="stylesheet"
              type="text/css"
            />
          )}
          <style id="post-css">{postCss}</style>
        </>
      )}
      <ColorStyles />
      <DeactivateInteractiveElementsStyles />
    </>
  );
}

function ColorStyles() {
  const cssVariables = useAtomValue(allCssVariablesAtom);
  return (
    <style id="post-colors">
      {`
      body {
          ${Object.entries(cssVariables ?? {})
            .map(([key, value]) => `${key}: ${value};`)
            .join('\n')}
      }
      `}
    </style>
  );
}

function HomeCSSVariables() {
  const cssVariables = useAtomValue(homeCssVariablesAtom);
  return (
    <style id="home-css-variables">
      {`
        body {
          ${Object.entries(cssVariables ?? {})
            .map(([key, value]) => `${key}: ${value};`)
            .join('\n')}
      }`}
    </style>
  );
}

function DeactivateInteractiveElementsStyles() {
  return (
    <style id="deactivate-interactive-elements">
      {/* Disable all interactive elements */}
      {`
        a,
        button,
        input[type="button"],
        input[type="submit"],
        input[type="reset"],
        select,
        textarea,
        input,
        [role="button"],
        [role="link"],
        [tabindex]:not([tabindex="-1"]) {
          pointer-events: none !important;
          cursor: default !important;
        }
      `}
      {/* Remove focus indicators */}
      {`
        a:focus,
        button:focus,
        input:focus,
        select:focus,
        textarea:focus,
        [role="button"]:focus,
        [role="link"]:focus {
          outline: none !important;
          box-shadow: none !important;
        }
      `}
      {/* Disable form submissions */}
      {`
        form {
          pointer-events: none !important;
        }
      `}
    </style>
  );
}
